import { FolderTypeEnum } from "../../enums/FolderTypeEnum";
import { IItemCheck } from "./IItemCheck";
import { NormalDriveItemCheck } from "./NormalDriveItemCheck";
import { OneDriveRootItemCheck } from "./OneDriveRootItemCheck";
import { SharepointListCheck } from "./SharepointListCheck";
import { SharepointSiteCheck } from "./SharepointSiteCheck";
import { TeamSiteCheck } from "./TeamSiteCheck";

export class ItemCheckFactory {
    constructor(private driveId?: string, private listId?: string, private siteId?: string) { }
    createItemChecker(folderType: FolderTypeEnum, isTeamsSiteInsideSharepoint: boolean = false): IItemCheck {
        if (folderType === FolderTypeEnum.sharepointSite || folderType === FolderTypeEnum.docubird || folderType === FolderTypeEnum.sharepointHubSite || isTeamsSiteInsideSharepoint) {
            return new SharepointSiteCheck();
        }

        if (folderType === FolderTypeEnum.teamMainSite) {
            return new TeamSiteCheck();
        }

        if (folderType === FolderTypeEnum.sharepointList) {
            return new SharepointListCheck(this.listId, this.siteId);
        }

        if (folderType === FolderTypeEnum.oneDrive) {
            return new OneDriveRootItemCheck();
        }

        return new NormalDriveItemCheck(this.driveId);
    }
}
